import { ReactNode } from "react";
import { StepTileProgressStatus } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";

export const renderHeadIcon = (
  icon: ReactNode,
  status: StepTileProgressStatus,
): ReactNode => {
  const loading = status === StepTileProgressStatus.IN_PROGRESS;
  const isActive = status === StepTileProgressStatus.ACTIVE;

  const iconClassnames = classNames(styles.flexIcon, {
    [styles.selectedIcon]: isActive,
  });

  if (loading) {
    return <div className={styles.spinner}></div>;
  } else {
    return <div className={iconClassnames}>{icon}</div>;
  }
};
